import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>Land use dynamics and forest fragmentation analyses:</li>
              </ol>
            </p>
            <p>
              The analyses of temporal Landsat data have been done to understand
              the land use changes from 1973 to 2021 in the Chikamagaluru
              district of Karnataka (Fig. 3, table 2), which shows a decrease in
              forest cover of 28.98%, with a raise in agriculture (crop area by
              5.31%, and horticulture by 42.52%) in last five decades.
            </p>
            <p>&nbsp;</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/cs3.png" alt="" />
            </p>

            <ol>
              <li>
                <p>
                  Table 2. Land use changes from 1973 to 2021 in Chikamagaluru
                  district
                </p>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style={styles.cell} colspan="2" width="30%">
                        <p>Land Use</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>
                          <strong>1973</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>
                          <strong>1991</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>
                          <strong>1998</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>
                          <strong>2005</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>
                          <strong>2013</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>
                          <strong>2021</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Evergreen</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1293.59</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1175.42</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1155.50</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1107.73</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1060.33</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>705.48</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>17.93</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>16.30</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>16.02</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>15.36</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>14.70</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>9.78</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Moist Deciduous</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1645.18</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1174.90</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1241.76</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1192.58</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1008.58</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1138.02</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>22.81</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>16.29</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>17.22</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>16.53</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>13.98</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>15.78</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Dry Deciduous</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>406.67</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>478.34</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>297.81</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>355.85</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>376.41</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>367.47</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.64</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>6.63</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>4.13</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>4.93</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.22</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.09</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Shola forest</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>390.77</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>271.17</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>272.04</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>201.81</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>327.33</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>249.61</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.42</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>3.76</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>3.77</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>2.80</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>4.54</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>3.46</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Scrub land</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>674.65</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>499.94</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>365.35</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>390.32</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>374.30</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>256.98</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>9.35</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>6.93</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.07</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.41</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>5.19</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>3.56</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Waterbody</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>125.84</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>160.93</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>143.28</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>90.67</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>146.95</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>124.48</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.74</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>2.23</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.99</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.26</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>2.04</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.73</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Crop land</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>600.74</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>615.07</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>831.17</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>878.65</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>909.55</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>974.78</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>8.33</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>8.53</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>11.52</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>12.18</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>12.61</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>13.51</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Fallow land</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1542.28</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1610.01</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1461.35</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1445.67</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1390.16</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1380.31</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>21.38</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>22.32</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>20.26</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>20.04</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>19.27</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>19.14</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Horticulture</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>313.43</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1044.68</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1270.19</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1382.50</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1418.43</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1807.16</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>4.35</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>14.48</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>17.61</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>19.17</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>19.66</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>25.05</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Open space</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>187.04</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>138.61</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>130.09</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>109.65</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>125.91</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>103.27</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>2.59</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.92</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.80</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.52</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.75</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.43</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} rowspan="2" width="19%">
                        <p>Built-up</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>sq. km</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>32.84</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>43.96</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>44.50</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>57.61</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>75.09</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>105.48</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="11%">
                        <p>%</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>0.46</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>0.61</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>0.62</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>0.80</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.04</p>
                      </td>
                      <td style={styles.cell} width="11%">
                        <p>1.46</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>&nbsp;</p>
                <p>&nbsp;</p>

                <p>&nbsp;</p>
              </li>
            </ol>
            <p>
              The total forest cover declined from 44.60% (1973) to 30.69%
              (2021). The evergreen forest changed from 800.14 sq. km (1973),
              785.41 sq. km (1991), 770.14 sq. km (1998), 711.63 sq. km (2005),
              716.5 sq. km (2013) to 706.38 sq. km (2021). The moist deciduous
              forest decreased from 1960.01 sq. km (1973) to 1139.64 sq. km
              (2021). Degradation in dry deciduous forests was seen from 457.41
              sq. km (1973) to 368.03 sq. km (2021). The shola forest between
              the evergreen hills has also decreased from 426.96 sq. km (1973)
              to 249.82 sq. km (2021). The scrub cover area decreased from
              707.86 sq. km (1973) to 256.97 sq. km (2021). The conversion of
              forested areas into agricultural and horticultural land is the
              prime reason for extensive degradation and deforestation in the
              study area. The Bhadra Wildlife Sanctuary and Kudremukh National
              Park was marked as a reserved forest, which has the densest forest
              region in the district and has also seen forest degradation in the
              edge of the national park area.
            </p>
            <p>
              The area covering agricultural activity was around 2174.46 sq. km
              (in 1973), which increased to 2358.52 sq. km (in 2021). There is a
              constant increase in agricultural land use due to the increased
              water availability from Bhadra dam in the district, which marks an
              increase of 5.31% from 1973 to 2021. The area under horticulture
              increased from 4.64 % (1973) to 25.05% (2021), showing a rise of
              42.52%. Many parts of forest and agricultural lands have been
              changed into horticultural land of coffee, pepper, and silver oak
              in the last five decades.
            </p>
            <p>
              The change in open spaces was seen in agricultural fields and
              built-up areas. The area under built-up also increased by 1.97%
              (31.66 sq. km in 1973 increased to 99.77 sq. km in 2021).
              Unregulated anthropogenic activities leading to escalation in the
              agricultural and horticultural activities were prime reasons for
              land degradation, leading to deforestation and severe decline
              ecosystem goods and services.
            </p>
            <p>
              Assessment of the condition of forest ecosystems through the
              structure of the forest (Fig 3, table 3) showed that the interior
              forest had declined from 55.72% (1973) to 28.05% (2021) with an
              increase in patch forest (0.79 sq. km), transitional forest
              (129.76 sq. km), edge forest (368.33 sq. km), and perforated
              forest (2023.07 sq. km).
            </p>

            <table width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="18%">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>&nbsp;</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>1973</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>1991</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>1998</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>2005</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>2013</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>
                      <strong>2021</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Exterior</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2676.33</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3452.33</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3737.29</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3874.08</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3919.15</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>4371.01</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>37.10</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>47.86</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>51.81</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>53.71</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>54.33</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>60.60</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Patch</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.17</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.53</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.57</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>8.73</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.84</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.79</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.00</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.01</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.01</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.12</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.01</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.01</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Transitional</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>32.38</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>107.78</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>119.72</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>129.22</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>122.61</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>129.77</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>0.45</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.49</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.66</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.79</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.70</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.80</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Edge</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>260.05</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>364.75</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>375.05</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>343.65</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>374.05</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>368.34</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3.61</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>5.06</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>5.20</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>4.76</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>5.19</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>5.11</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Perforated</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>99.37</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>267.44</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>237.72</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>252.18</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>236.99</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>195.59</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.38</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3.71</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3.30</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3.50</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>3.29</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2.71</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Interior</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>4018.89</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2859.26</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2599.42</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2514.51</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2412.46</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2023.07</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>55.72</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>39.64</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>36.04</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>34.86</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>33.45</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>28.05</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="18%">
                    <p>Waterbody</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>sq. km</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>125.84</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>160.93</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>143.28</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>90.67</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>146.95</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>124.48</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="11%">
                    <p>%</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.74</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2.23</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.99</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.26</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>2.04</p>
                  </td>
                  <td style={styles.cell} width="11%">
                    <p>1.73</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <ol>
                <li>Carbon Assessment:</li>
              </ol>
            </p>
            <p>
              Carbon content in forest ecosystems of Chikamagaluru district
              &nbsp;has been quantified by using field data and literature
              review. The study shows the forest ecosystems of Chikamagaluru
              have an irreplaceable stock of carbon, which aided in the
              mitigation of global warming. The above-ground biomass in 1973 was
              55706.29 Gg, which decreased to 38781.6 Gg in 2021 due to
              extensive land cover changes. A similar trend can be seen in
              below-ground biomass (3426.41 Gg decrease) and soil and dead
              biomass (1033.71 Gg decrease). The total carbon decreased by
              30683.81 Gg from 1973 to 2021 (Fig 4, Table 4).
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/cs4.png" alt="" />
            </p>

            <ol>
              <li>
                <p>
                  Table 4. Carbon Assessment of Chikamagaluru district from 1973
                  to 2021
                </p>
                <p>&nbsp;</p>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>Carbon Assessment</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>AGB (Gg)</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>BGB (Gg)</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>Soil + dead (Gg)</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>AGB+BGB+S+D (Gg)</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>
                          <strong>1973</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>55706.29</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>11241.27</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>34306.46</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>101254.02</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>
                          <strong>1991</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>46119.49</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>9303.11</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>29063.48</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>84486.08</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>
                          <strong>1998</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>44224.56</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>8914.85</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>27133.85</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>80273.26</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>
                          <strong>2005</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>43140.73</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>8694.37</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>26556.41</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>78391.51</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>
                          <strong>2013</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>40193.41</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>8110.32</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>25358.36</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>73662.09</p>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.cell} width="23%">
                        <p>
                          <strong>2021</strong>
                        </p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>38781.6</p>
                      </td>
                      <td style={styles.cell} width="15%">
                        <p>7814.86</p>
                      </td>
                      <td style={styles.cell} width="16%">
                        <p>23973.75</p>
                      </td>
                      <td style={styles.cell} width="29%">
                        <p>70570.21</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <strong>&nbsp;</strong>
                </p>
              </li>
            </ol>
            <ul>
              <li>Appraisal of Climate Variability:</li>
            </ul>
            <p>
              Figure 5 depicts the current temperature (&deg;C), number of rainy
              days and annual rainfall (mm), in the Chikamagaluru district
              (13&deg; to 14&deg; N latitude), which shows that Chikamagaluru
              has an average temperature of less than 25&deg;C, 120 to 150 rainy
              days in a year and annual rainfall of&nbsp; &gt;3000 mm. The
              analysis of climatic trend through long-term climatic data,
              presented in fig 5 highlight that the study area will experience
              &lt; 0.5&deg;C increase in temperature, 0 to 100 mm increase in
              rainfall, and 2 to 4 days increase in rainy days, which are
              comparable to the climatic trends in the Western Ghats
              (Ramachandra and Bharath 2019).
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/cs5.png" alt="" />
            </p>

            <p>
              <strong>Discussion:</strong>
            </p>
            <p>
              Land use transitions in Chikamagaluru district are due to
              escalating agricultural and horticultural activities in the forest
              ecosystem during the past five decades (Nagaraja et al. 2014, p.
              32). Sustenance of the current situation of land degradation and
              trend with the lack of timely ecosystem restoration has been
              posing a serious threat to food security with the erosion in the
              hydrological and ecological services, which has been impacting the
              livelihood of the local people. Declining carbon stock and
              sequestration potential necessitate an immediate eco-restoration
              and implementation of stringent policies and norms for the
              protection of ecologically fragile regions.
            </p>
            <p>
              The study highlights that land-use alterations have significantly
              impacted a district's micro-climate. Forests, often referred to as
              "water towers," play a pivotal role in capturing atmospheric
              moisture through rainfall and aiding in condensation (Bonan 2008,
              p. 1444). The decline in natural forest cover has reduced surface
              roughness, a change in the hydrological regime, and altered
              aerodynamics. Consequently, rain-bearing clouds now follow
              prevailing winds, resulting in rainfall primarily in windward
              areas. Climate change is evident with alterations in the spatial
              patterns of rainfall accompanied by the trend of an increase in
              rainy days and rainfall in the Northern Western Ghats, and a
              decrease in rainy days and rainfall in the Southern Western Ghats,
              which will result in recurring instances of flash floods and
              drought-like conditions (Ramachandra Bharath 2019, p. 2765).
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
